<template>
  <el-dialog title="修改" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form size="small" :model="formData" :rules="formRules" ref="form">

      <el-form-item label="内容" prop="content" :label-width="formLabelWidth">
        {{ selectModel.content }}
      </el-form-item>

      <el-form-item label="手机" prop="mobile" :label-width="formLabelWidth">
        {{ selectModel.mobile }}
      </el-form-item>

      <el-form-item label="回复" prop="reply" :label-width="formLabelWidth">
        <el-input type="textarea" v-model="formData.reply" :rows="5" placeholder="请输入回复"></el-input>
      </el-form-item>
      
    </el-form>
    <!--操作按钮-->
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="onSubmit()" :disabled="loading">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import FeedbackApi from '@/api/study/feedback.js';
export default {
  data() {
    return {
      /*是否加载中*/
      loading: false,
      /*form表单数据对象*/
      formData: {
        reply: '',
      },
      /*验证规则*/
      formRules: {
        reply: [{ required: true, message: '请输入回复', trigger: 'blur' }],
      },
      /*排序*/
      srot: 100,
      /*左边长度*/
      formLabelWidth: '120px',
      /*是否显示*/
      dialogVisible: false,
    };
  },
  props: {
    open_edit:Boolean,
    selectModel:Object,
  },
  created() {
    this.dialogVisible = this.open_edit;
    this.formData.reply = this.selectModel.reply;
  },
  methods: {
    /*选择分类*/
    handleChange(e) {
    },

    /*修改分类*/
    onSubmit() {
      let self = this;
      let params = self.formData;
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          params.id = self.selectModel.id;
          FeedbackApi.reply(params, true)
            .then(res => {
              if (res.code == 1) {
                self.$message({
                  message: res.msg,
                  type: 'success',
                });
                self.$emit('closeDialog', {
                  type: 'success',
                  openDialog: false,
                  data:params
                });
                self.loading = false;
              }
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*关闭弹窗*/
    dialogFormVisible(e) {
      this.$emit('closeDialog', {
        type: 'error',
        openDialog: false
      });
    },
    
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/study/feedback/part/Edit.vue